import { ReactNode } from "react";
import { ConceptFlowLinkPath } from "@/app/types/illustrations/ConceptFlowLink";
import { CONCEPT_FLOW_VIRTUAL_WIDTH } from "./IlluConceptFlowLinks.logic";
import styles from "./IlluConceptFlowLinks.module.css";

type Props = {
  height: number;
  links: ConceptFlowLinkPath[];
  className?: string;
  children?: ReactNode;
};

export function IlluConceptFlowLinks(props: Props) {
  const { height, links, className, children } = props;

  return (
    <svg
      className={`${styles.links} ${className ?? ""}`}
      viewBox={`0 0 ${CONCEPT_FLOW_VIRTUAL_WIDTH} ${height}`}
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      {links.map((link) => (
        <path className={styles.link} d={link.d} key={link.id} />
      ))}
      {children}
    </svg>
  );
}
